export const SUGGESTED_CATERING_PROMPTS = [
  'What are my delivery days?',
  'Explain my order cutoff',
  "What's on my menu?"
]

export const SUGGESTED_ECOMMERCE_PROMPTS = [
  "What's running low on stock?",
  'What discounts do I have running?',
  'How do I hide times at checkout?'
]

export function suggestedPromptsForPlatform(platform) {
  return platform === 'ecommerce' ? SUGGESTED_ECOMMERCE_PROMPTS : SUGGESTED_CATERING_PROMPTS
}

export function showChatWelcome(messages, typing) {
  return (messages || []).length === 0 && !typing
}
